<header #header>
  @if (!isOnLandingPage()) {
    <app-link variant="white" routerLink="/home" class="icon home">
      <img src="icons/home.svg" i18n-alt alt="home" />
    </app-link>
  } @else {
    <div></div>
  }
  <app-link variant="white" routerLink="/home">
    <div class="title">
      <img src="icons/logo.svg" alt="" />
      <div i18n class="title">InnovationHub</div>
    </div>
  </app-link>
  <nav>
    @if (user()?.permissions?.includes("customerfeedback:read")) {
      <app-link variant="white" routerLink="/customer-feedback">
        <img src="icons/customer-feedback.svg" i18n-alt alt="customer feedback administration" class="icon" />
      </app-link>
    }
    @if (user()?.permissions?.includes("analytics:read")) {
      <app-link variant="white" routerLink="/admin">
        <img src="icons/administration.svg" i18n-alt alt="administration" class="icon" />
      </app-link>
    }
    @if (user()) {
      <app-button variant="basic" (buttonClick)="toggleMenu()">
        <img src="icons/profile2.svg" i18n-alt alt="profile" class="icon" />
      </app-button>
    } @else {
      <app-button i18n variant="basic-white" (buttonClick)="doLogin()">Login</app-button>
    }
    @if (isOnLandingPage()) {
      <app-button i18n class="get-started" variant="tertiary" (buttonClick)="doSignUp()">Get started</app-button>
    }
  </nav>
  @if (menuOpen()) {
    <app-header-menu />
  }
</header>
